import Vue from 'vue'
import App from './App.vue'
import {i18n} from './plugins/i18n'
import {router} from './router'
import store from './store'
import jQuery from 'jquery'
import VueXlsx from 'vue-js-xlsx'
import VueMask from 'v-mask'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/tr-TR'
import VueApexCharts from 'vue-apexcharts'
import VueGeolocation from 'vue-browser-geolocation';
import {HotTable} from '@handsontable/vue';
import Handsontable from 'handsontable';


global.jQuery = jQuery;
global.$ = jQuery;

Vue.use(VueGeolocation);
Vue.use(VueXlsx);
Vue.use(ElementUI, {locale});
Vue.use(VueMask);
Vue.use(HotTable);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import 'bootstrap'
import 'jquery/dist/jquery.min'

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  VueMask,
  HotTable,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js